import { clsx } from 'clsx';
import * as React from 'react';
import * as style from './style.css';

interface IGkCardLayoutProps extends React.PropsWithChildren {
  addTopMarginToFirst?: boolean;
}

export const GkCardLayout: React.FC<IGkCardLayoutProps> = ({ children, addTopMarginToFirst }) => {
  return (
    <div
      data-name="GKCardComponent"
      className={clsx(style['layout'], addTopMarginToFirst && style['first-with-margin'])}
      data-mark="GKCard"
    >
      {children}
    </div>
  );
};
